export const DURATIONS = [
  'last-24-h',
  'last-7-days',
  'last-30-days',
  'last-6-months',
  'last-1-year',
] as const;

export type IDuration = typeof DURATIONS[number];
